import api from './api';

const BASE_URL = '/support-widget';

const toFormData = ({ subject, description, ticket_type, priority, comment, images }) => {
  const formData = new FormData();
  if (subject !== undefined) formData.append('subject', subject);
  if (description !== undefined) formData.append('description', description);
  if (ticket_type !== undefined) formData.append('ticket_type', ticket_type);
  if (priority !== undefined) formData.append('priority', priority);
  if (comment !== undefined) formData.append('comment', comment);
  (images || []).forEach((file) => formData.append('images', file));
  return formData;
};

// `resource` is 'tickets' (my own requests, any staff) or 'inbox' (every conversation,
// owner/admin only) -- same shapes, different backend scoping.
const buildService = (resource) => ({
  getAll: async () => {
    const response = await api.get(`${BASE_URL}/${resource}`);
    return response.data;
  },

  getOne: async (id) => {
    const response = await api.get(`${BASE_URL}/${resource}/${id}`);
    return response.data;
  },

  addComment: async (id, comment, images) => {
    const response = await api.post(
      `${BASE_URL}/${resource}/${id}/comments`,
      toFormData({ comment, images }),
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  sendTyping: async (id) => {
    try {
      await api.post(`${BASE_URL}/${resource}/${id}/typing`);
    } catch (error) {
      // best-effort, never worth surfacing to the user
    }
  },
});

export const supportWidgetService = {
  ...buildService('tickets'),

  createTicket: async ({ subject, description, ticket_type, priority, images }) => {
    const response = await api.post(
      `${BASE_URL}/tickets`,
      toFormData({ subject, description, ticket_type, priority, images }),
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },
};

export const supportInboxService = {
  ...buildService('inbox'),

  updateStatus: async (id, status) => {
    const response = await api.patch(`${BASE_URL}/inbox/${id}/status`, { status });
    return response.data;
  },
};

export default supportWidgetService;
